
import React from 'react';

export function useRestaurantFormState() {
  // Restaurant specific states
  const [mealPriceRange, setMealPriceRange] = React.useState('');
  const [cuisineSpecialties, setCuisineSpecialties] = React.useState('');
  const [dressCode, setDressCode] = React.useState('');
  const [outdoorSeating, setOutdoorSeating] = React.useState(false);

  const resetRestaurantFormState = () => {
    setMealPriceRange('');
    setCuisineSpecialties('');
    setDressCode('');
    setOutdoorSeating(false);
  };

  return {
    mealPriceRange, setMealPriceRange,
    cuisineSpecialties, setCuisineSpecialties,
    dressCode, setDressCode,
    outdoorSeating, setOutdoorSeating,
    resetRestaurantFormState
  };
}
